const TRANSLATION = {
  common: {
    loading: 'جارٍ التحميل',
  },
  i18n: {
    English: 'الإنجليزية',
    Spanish: 'الإسبانية',
    Russian: 'الروسية',
    'Portuguese (Brazil)': 'البرتغالية (البرازيل)',
    Indonesian: 'الإندونيسية',
    Czech: 'التشيكية',
    German: 'الألمانية',
    French: 'الفرنسية',
    Italian: 'الإيطالية',
    Dutch: 'الهولندية',
    Polish: 'البولندية',
    Vietnamese: 'الفيتنامية',
    Turkish: 'التركية',
    Ukrainian: 'الأوكرانية',
    Chinese: 'الصينية المبسطة',
    'Traditional Chinese': 'الصينية التقليدية',
    Japanese: 'اليابانية',
    Korean: 'الكورية',
    Arabic: 'العربية',
    Persian: 'الفارسية',
    Thai: 'التايلاندية',
    Hindi: 'الهندية',
    Malay: 'الملايو',
    province: {
      Hebei: 'مقاطعة خبي',
      Shanxi: 'مقاطعة شانشي',
      Liaoning: 'مقاطعة لياونينغ',
      Jilin: 'مقاطعة جيلين',
      Heilongjiang: 'مقاطعة هيلونغجيانغ',
      Jiangsu: 'مقاطعة جيانغسو',
      Zhejiang: 'مقاطعة تشجيانغ',
      Anhui: 'مقاطعة أنهوي',
      Fujian: 'مقاطعة فوجيان',
      Jiangxi: 'مقاطعة جيانغشي',
      Shandong: 'مقاطعة شاندونغ',
      Henan: 'مقاطعة خنان',
      Hubei: 'مقاطعة هوبي',
      Hunan: 'مقاطعة هونان',
      Guangdong: 'مقاطعة قوانغدونغ',
      Hainan: 'مقاطعة هاينان',
      Sichuan: 'مقاطعة سيتشوان',
      Guizhou: 'مقاطعة قويتشو',
      Yunan: 'مقاطعة يونان',
      Shaanxi: 'مقاطعة شنشي',
      Gansu: 'مقاطعة قانسو',
      Qinghai: 'مقاطعة تشينغهاي',
      Taiwan: 'مقاطعة تايوان',
      Guangxi: 'منطقة قوانغشي الذاتية الحكم لقومية تشوانغ',
      Neimenggu: 'منطقة منغوليا الداخلية الذاتية الحكم',
      Tibet: 'منطقة التبت الذاتية الحكم',
      Ningxia: 'منطقة نينغشيا الذاتية الحكم لقومية هوى',
      Xinjiang: 'منطقة شينجيانغ الويغورية الذاتية الحكم',
      HongKong: 'منطقة هونغ كونغ الإدارية الخاصة',
      Macau: 'منطقة ماكاو الإدارية الخاصة',
      Beijing: 'بلدية بكين',
      Tianjin: 'بلدية تيانجين',
      Shanghai: 'بلدية شنغهاي',
      Chongqing: 'بلدية تشونغتشينغ',
    },
  },
  pageHeader: {
    product: 'المنتج',
    tvcTest: 'اختبار تجربة TVC',
    tvcEval: 'تقييم إبداع TVC',
    contactUs: 'اتصل بنا',
    Pricing: 'التسعير',
    Dashboard: 'ابدأ الآن',
    signIn: 'تسجيل الدخول',
    signUp: 'إنشاء حساب',
    resourceCenter: 'المدونة',
    all: 'الكل',
    news: 'الأخبار',
    insight: 'الأدراك',
    case: 'الأمثلة',
  },
  productSwitch: {
    common: {
      comingSoon: 'قريبًا',
    },
    modal: {
      heroTitle: 'يرجى اختيار الاختبار الذي ترغب في تشغيله',
      heroSubtitle: 'إن AdEff جاهز دائمًا لتقديم رؤى إبداعية متعددة الأبعاد كلما احتجت إليها.',
      remainingTimes: 'المحاولات المتبقية: {{count}}',
      supportedAssets: 'المواد المدعومة',
      coreMetrics: 'المؤشرات الأساسية',
      cognitiveNeuroscienceIndicators: 'مؤشرات معرفية-عصبية',
      consumerAttitudeIndicators: 'مؤشرات موقف المستهلك',
      outputResult: 'نتيجة المخرجات',
      dataReport: 'تقرير البيانات',
      analysisReport: 'تقرير التحليل',
      accessBackend: 'ابدأ الآن',
      tabs: {
        tvc: 'اختبار الإبداع الأفقي',
        portrait: 'اختبار الإبداع العمودي',
      },
      cards: {
        tvcQuick: {
          title: 'أفقي-اختبار سريع',
          descriptionHighlight: 'قيّم المواد الإبداعية بسرعة لدعم قرارات مستندة إلى البيانات',
        },
        tvcBase: {
          title: 'تشخيص الإبداع-الأفقي',
          descriptionHighlight: 'صقّل التفاصيل الإبداعية مع اقتراحات تعديل قابلة للتنفيذ',
          value1: 'إبداعات TVC/OTV من 10 إلى 60 ثانية',
          value2: 'مؤشرات معرفية-عصبية',
        },
        tvcSurvey: {
          title: 'رؤى أفقية-معمقة',
          descriptionHighlight: 'تحليل إبداعي متعدد الأبعاد مع إرشاد استراتيجي للتحسين',
          value1: 'إبداعات TVC/OTV من 10 إلى 60 ثانية',
          value2: 'مؤشرات معرفية-عصبية',
        },
        portraitQuick: {
          title: 'عمودي-اختبار سريع',
          descriptionHighlight: 'قيّم المواد الإبداعية بسرعة لدعم قرارات مستندة إلى البيانات',
        },
        portraitBase: {
          title: 'تشخيص الإبداع-العمودي',
          descriptionHighlight: 'صقّل التفاصيل الإبداعية مع اقتراحات تعديل قابلة للتنفيذ',
          value1: 'إبداعات عمودية من 5 إلى 90 ثانية',
          value2: 'مؤشرات معرفية-عصبية',
        },
        portraitSurvey: {
          title: 'رؤى عمودية-معمقة',
          descriptionHighlight: 'تحليل إبداعي متعدد الأبعاد مع إرشاد استراتيجي للتحسين',
          value1: 'إبداعات عمودية من 5 إلى 90 ثانية',
          value2: 'مؤشرات معرفية-عصبية',
        },
      },
    },
    hoverPanel: {
      columns: {
        tvc: {
          bannerTitle: 'اختبار الإبداع الأفقي',
          assetText: 'مناسب لإبداعات TVC/OTV من 10 إلى 60 ثانية',
        },
        portrait: {
          bannerTitle: 'اختبار الإبداع العمودي',
          assetText: 'مناسب لإبداعات الفيديو العمودي من 5 إلى 90 ثانية',
        },
      },
      items: {
        tvcQuick: {
          description: 'قارن المواد الإبداعية بسرعة واتخذ القرار',
        },
        tvcBase: {
          title: 'تشخيص الإبداع',
          description: 'تحسين ثانية بثانية لصقل الإبداعات',
        },
        tvcSurvey: {
          title: 'رؤى معمقة',
          description: 'تحليل شامل لتحديد المشكلات بدقة',
        },
        portraitBase: {
          title: 'تشخيص الإبداع',
          description: 'تحسين ثانية بثانية لصقل الإبداعات',
        },
        portraitQuick: {
          description: 'قارن المواد الإبداعية بسرعة واتخذ القرار',
        },
        portraitSurvey: {
          title: 'رؤى معمقة',
          description: 'تحليل شامل لتحديد المشكلات بدقة',
        },
      },
    },
  },
  cookieAcceptNotification: {
    title: 'نحن نستخدم ملفات تعريف الارتباط',
    desc: 'نستخدم ملفات تعريف الارتباط الضرورية لضمان تشغيل موقعنا بشكل صحيح. بموافقتك، نستخدم أيضًا ملفات تعريف الارتباط التحليلية لتحسين تجربتك. راجع سياسة ملفات تعريف الارتباط الخاصة بنا في سياسة الخصوصية.',
    btn1: 'رفض الكل',
    btn2: 'قبول الكل',
    cookiePolicy: 'سياسة ملفات تعريف الارتباط',
  },
  landing: {
    banner: {
      text1: 'مدفوع بالذكاء الاصطناعي',
      text2: 'الإعلانات',
      text3: 'الاختبار',
      text4: 'منصة اختبار وتحسين الإبداع',
      feature1: 'فك تشفير المحتوى',
      feature2: 'توقع التعليقات',
      feature3: 'دمج البيانات',
      feature4: 'استنتاجات وتوصيات',
      btn1: 'احصل على عرض توضيحي',
      btn2: 'إنشاء مشروع',
    },
    info: {
      title:
        'استنادًا إلى نموذج اللغة الكبير متعدد الأنماط (HMLLM)*، تحقق بسرعة من توقعات فعالية الإبداع وزيادة العائد على الاستثمار في الإعلانات',
      subTitle:
        '*هذا النموذج يعتمد على عدد كبير من الاختبارات العصبية النفسية وبناء وكالات متعددة.',
      detail1: 'اختبار الإعلانات بسرعة',
      detail1Desc:
        'يمكن لـ AdEff الحصول على منحنى انتباه الجمهور المستهدف، وتقلبات المشاعر، ومشاركة المحتوى الإبداعي في 15 دقيقة وتقديم تقرير مفصل وتوجيهات للتحسين.',
      detail2: 'اختيار الإبداع الأفضل بسرعة',
      detail2Desc:
        'يدعم AdEff قياس عدة إبداعات في وقت واحد، مما يساعد العلامات التجارية على اتخاذ قرارات سريعة. ويقدم تحليلاً مقارناً مفصلاً.',
      detail3: 'تحرير بنقرة واحدة، إنشاء نسخ فعالة متنوعة',
      detail3Desc:
        'يدعم AdEff التحرير بنقرة واحدة، مما يتيح إنشاء نسخ فعالة متنوعة بسرعة، مناسبة لمجموعة متنوعة من سيناريوهات النشر.',
    },
    advantages: {
      title: 'مزايا AdEff',
      item1Title: 'استجابة سريعة',
      item1Desc: 'أسرع تقرير في <tmp>15 دقيقة</tmp>.',
      item2Title: 'نموذج ذكاء اصطناعي فريد',
      item2Desc: 'نموذج <tmp>ذكاء اصطناعي</tmp> الفريد القائم على تعليقات الجمهور.',
      item3Title: 'رسوم بيانية مرئية',
      item3Desc:
        '<tmp>رسوم بيانية مرئية</tmp> + تفسير الذكاء الاصطناعي، تقرير الاختبار بنقرة واحدة',
      item4Title: 'نطاق بيانات ضخم',
      item4Desc: '<tmp>50,000+</tmp> قاعدة بيانات الإبداع',
      item5Title: 'فريق من الخبراء',
      item5Desc: '<tmp>فريق من الخبراء</tmp> يقدم الدعم والتوجيه',
    },
    service: {
      title: 'طرق خدمة AdEff',
      desc: 'اختر طريقة الخدمة التي تحتاجها',
      topTitle: 'خدمة ذاتية عبر الإنترنت',
      topRow1: 'إنشاء مشروع واختباره بنفسك',
      topRow2: 'رسوم بيانية مرئية + تقرير تفسير الذكاء الاصطناعي',
      topRow3: 'تحليل موضوعي لمؤشرات العلوم العصبية (حركة العين + EEG)',
      topRow4: 'اختبار نموذج الذكاء الاصطناعي الفريد',
      bottomTitle: 'خدمات فريق الخبراء',
      bottomRow1: 'إنشاء مشروع واختباره بواسطة الخبراء',
      bottomRow2:
        'تحليل موضوعي لمؤشرات العلوم العصبية (حركة العين + EEG)، مع إمكانية إضافة مؤشرات ذاتية',
      bottomRow3: 'رسوم بيانية مرئية + تقرير تفسير خبير',
      bottomRow4: 'اختبار نموذج الذكاء الاصطناعي الفريد، مع إمكانية اختبار عينات حقيقية',
    },
    footer: {
      title:
        'يستند AdEff إلى نموذج اللغة الكبير متعدد الأنماط (HMLLM)، من خلال بناء علاقات معقدة بين العناصر المرئية وإشارات EEG وبيانات تتبع العين لتحقيق اختبار سريع للإبداع الإعلاني',
      email: 'البريد الإلكتروني',
      belongDesc: 'منتج من <tmp>Mininglamp Technology</tmp>',
    },
    startBtn: 'ابدأ الآن',
  },
  contact: { title: 'اتصل بنا', copy: 'نسخ', message: { success: 'تم النسخ بنجاح' } },
  pricing: {
    title: 'خبير اختبار وتحسين الإبداع المدفوع بالذكاء الاصطناعي',
    starter: {
      title: 'بدء التشغيل',
      desc_1: 'مناسب للاختبارات لمرة واحدة وجاهز للاستخدام فور الشراء',
      desc_2: 'مناسب للاختبارات صغيرة الحجم وجاهز للاستخدام فور الشراء',
      timesDesc: '<strong>{{count}}</strong> مرة اختبار',
      timesDesc1: '<strong>{{count}}</strong> مرة اختبار',
      discount: 'خصم 50٪',
      originPrice: 'السعر الأصلي',
      desc2: 'نموذج ذكاء اصطناعي فريد قائم على تعليقات الجمهور',
      desc3: 'استجابة سريعة، أسرع تقرير في 15 دقيقة',
      desc4: 'رسوم بيانية مرئية',
      desc5: 'تفسير الذكاء الاصطناعي',
      desc6: 'قاعدة بيانات عالمية',
      cardDesc1: 'خصم لفترة محدودة، فقط {{pricePerTest}}',
      cardDesc2: 'رصيد الاختبارات صالح دائمًا',
    },
    premium: {
      time: 'مرة',
    },
    unlimited: {
      title: 'متميز',
      cardDesc1: 'ابتداءً من {{pricePerTest}}',
      cardDesc2: 'الرصيد صالح لمدة سنة واحدة',
      cardDesc3: 'مرجع معياري مخصص خاص بك',
      planDesc500: 'استمتع بـ 500 اختبار على مدار العام',
      planDesc1000: 'استمتع بـ 1,000 اختبار على مدار العام',
    },
    benefits: {
      title: 'لماذا تختار AdEff؟',
      subtitle: 'مع AdEff، يمكنك الحصول على المزايا التالية:',
      expertSupport: 'دعم وتوجيه من فريق الخبراء',
      moreNeedsTitle: 'هل لديك احتياجات شراء أخرى؟',
      customPlanPrefix: 'ندعم خططًا مرنة ومخصصة — تواصل معنا على',
      customPlanSuffix: 'للحصول على حل مخصص لك',
    },
    subscribeBtn: 'اشترك الآن',
    contactUs: 'اتصل بنا',
  },
  login: {
    loginText: 'تسجيل الدخول',
    signUpText: '<tmp>إنشاء حساب</tmp> مجاني',
    text1: 'تم الانضمام إلى الفريق',
    text1Desc: 'يمكنك اختبار الإعلانات بنفسك',
    text2: 'انضم المستخدم إلى الشركة',
    text3: 'انتهت صلاحية دعوة الفريق',
    text4: 'رابط دعوة الفريق لم يعد صالحًا.',
    optionText1: 'هل لديك حساب بالفعل؟',
    optionText2: 'لا يوجد لديك حساب؟',
    alertText1: 'من خلال التسجيل، أوافق على',
    alertText2: 'أوافق على',
    termsOfService: 'شروط الخدمة',
    privacy: 'سياسة الخصوصية',
    privacyTips: 'يرجى التحقق من مربع الاتفاق قبل التسجيل.',
    and: 'و',
    or: 'أو',
    next: 'التالي',
    googleLogin: 'تسجيل الدخول باستخدام Google',
    googleSignUp: 'إنشاء حساب باستخدام Google',
    loginWithEmail: 'تسجيل الدخول باستخدام البريد الإلكتروني',
    signUpWithEmail: 'إنشاء حساب باستخدام البريد الإلكتروني',
    password: 'كلمة المرور',
    emailAddress: 'البريد الإلكتروني',
    enterEmail: 'أدخل البريد الإلكتروني الخاص بك',
    enterPassword: 'أدخل كلمة المرور الخاصة بك',
    confirmPassword: 'تأكيد كلمة المرور',
    forgotPassword: 'هل نسيت كلمة المرور؟',
    inconsistentPassword: 'كلمات المرور غير متطابقة',
    verificationCode: 'رمز التحقق',
    emptyVerificationCode: 'لا يمكن أن يكون رمز التحقق فارغًا',
    enterVerificationCode: 'أدخل رمز التحقق',
    sendedVerificationCode: 'تم إرسال رمز التحقق إلى بريدك الإلكتروني',
    emailOrPasswordNotCorrect: 'البريد الإلكتروني أو كلمة المرور غير صحيحة.',
    message: {
      text1: 'إدخال غير صالح',
      text2: 'البريد الإلكتروني مسجل بالفعل',
      text3: 'خطأ في التحقق من رمز التحقق!',
      text4: 'هذه الحساب غير مرتبط بالشركة، يرجى إعادة الربط!',
      text5: 'يرجى إدخال تنسيق البريد الإلكتروني الصحيح',
      text6: 'أقصر طول لكلمة المرور 12 حرف',
      text7: 'يجب أن تحتوي كلمة المرور على أحرف كبيرة وصغيرة وأرقام',
      requestLimit: 'تجاوز الحد، يرجى المحاولة لاحقًا',
    },
  },
  resetPwdPage: {
    submit: 'إرسال',
    emailNotFound: 'يرجى التحقق من البريد الإلكتروني',
    emailHasSent: 'تم إرسال البريد الإلكتروني إلى {{email}}',
    checkYourInbox: 'تحقق من صندوق البريد الإلكتروني',
    resetYourPassword: 'إعادة تعيين كلمة المرور',
    resetLinkHasSent: 'تم إرسال رابط إعادة تعيين كلمة المرور إلى بريدك الإلكتروني',
    enterYourEmailAddress:
      'أدخل البريد الإلكتروني الخاص بك وسنرسل لك رابطًا لإعادة تعيين كلمة المرور',
    didNotGetEmail: 'لم يستلم البريد الإلكتروني؟',
    tryAgain: 'حاول مرة أخرى',
    goBackToSign: 'العودة إلى تسجيل الدخول',
    email: 'البريد الإلكتروني',
    enterYourEmail: 'أدخل البريد الإلكتروني الخاص بك',
    resetPassword: 'إعادة تعيين كلمة المرور',
    resetPwdSuccess: 'تم إعادة تعيين كلمة المرور بنجاح',
    message: {
      resetLinkCodeError: 'رابط إعادة تعيين كلمة المرور غير صالح',
      requestLimit: 'تجاوز الحد، يرجى المحاولة لاحقًا',
    },
  },
  memberRequestPage: {
    title: 'تحقق من طلب العضو',
    subTitle: 'الطلب من:',
    deny: 'رفض',
    approve: 'الموافقة',
    teamFull: 'الفريق ممتلئ',
    yourTeamIsFull:
      'فريقك ممتلئ. يمكنك الاتصال بنا للحصول على المزيد من الأعضاء أو حذف أعضاء آخرين.',
    manageMembers: 'إدارة الأعضاء في AdEff',
    requestApproved: 'تمت الموافقة على الطلب',
    approvedDesc:
      'لقد وافقت على <tmp>{{name}}</tmp> للانضمام إلى فريقك، وتم إرسال إشعار بالبريد الإلكتروني تلقائيًا.',
    requestDeclined: 'تم رفض الطلب',
    declinedDesc:
      'لقد رفضت <tmp>{{name}}</tmp> للانضمام إلى فريقك، وتم إرسال إشعار بالبريد الإلكتروني تلقائيًا.',
  },
  infoBindPage: {
    title: 'اختبار الإعلانات المدفوع بالذكاء الاصطناعي',
    desc: 'استنادًا إلى نموذج اللغة الكبير متعدد الأنماط (HMLLM)*، تحقق بسرعة من توقعات فعالية الإبداع وزيادة العائد على الاستثمار في الإعلانات',
    joinAdEff: 'انضم إلى AdEff وابدأ رحلة جديدة',
    advantages: {
      title1: 'أكثر قوة',
      desc1: 'نموذج ذكاء اصطناعي فريد قائم على قاعدة بيانات ضخمة',
      title2: 'أكثر اقتصادية',
      desc2: 'فقط 10% من الأسعار التقليدية',
      title3: 'أكثر سرعة',
      desc3: 'أسرع تقرير في 15 دقيقة',
      title4: 'أكثر احترافية',
      desc4: 'استمتع بدعم على مدار الساعة، وخدمات فريق الخبراء',
    },
    username: 'اسم المستخدم',
    company: 'الشركة',
    placeOfResidence: 'الدولة/المنطقة',
    invitationCode: 'رمز الإحالة',
    createAccountForFree: 'إنشاء حساب مجاني',
    refreshStatus: 'تحديث الحالة',
    reapply: 'إعادة التقديم',
    bySigningUp: 'بالتسجيل، أنت توافق على',
    termsOfService: 'شروط الخدمة',
    and: 'و',
    privacyPolicy: 'سياسة الخصوصية',
    message: {
      success: 'تم إرسال طلب إنشاء الحساب، يرجى الانتظار!',
      success2: 'تم إنشاء الحساب بنجاح',
      error: 'فشل إنشاء الحساب، يرجى المحاولة لاحقًا.',
      accountCreatedDirectly: 'تم إنشاء حسابك مباشرة!',
      theRequestHasBeenApprovedAndIsJumpingThePageForYou:
        'تمت الموافقة على الطلب، وسيتم إعادة توجيه الصفحة تلقائيًا.',
      theRequestHasBeenSendAndPleaseBePatient: 'تم إرسال الطلب، يرجى الانتظار!',
      wrongRouting: 'خطأ في التوجيه، سيتم إعادة توجيه الصفحة تلقائيًا.',
      yourRequestHasBeenDeclined:
        'تم رفض طلبك. يمكنك إعادة التقديم للانضمام إلى الفريق أو إنشاء حساب جديد بدون رمز دعوة.',
      waitingForAdministratorReview: 'في انتظار مراجعة المسؤول',
      thisFieldIsRequired: 'هذا الحقل مطلوب',
      pleaseEnterTheResidence: 'يرجى إدخال الدولة',
      invitationCodeDoesNotExist: 'رمز الإحالة غير صالح',
      ifYourCompanyHaveBeenJoinedPleaseWriteHere:
        'إذا كنت تستخدم هذا من خلال إحالة وكيل، يرجى إدخال رمز الإحالة',
      pleaseEnterTheUsername: 'يرجى إدخال اسم المستخدم',
      pleaseEnterTheCompanyName: 'يرجى إدخال اسم الشركة',
      needRegisterAgain: 'خطأ في العملية، يرجى إعادة التسجيل',
      alreadyBind: 'لقد قمت بربط الشركة بالفعل، يرجى عدم الربط مرة أخرى',
    },
  },
  knowledgeFormPage: {
    name: 'اسمك',
    email: 'بريدك الإلكتروني',
    companyName: 'اسم الشركة',
    department: 'القسم',
    role: 'الدور الوظيفي',
    country: 'الدولة',
    province: 'المقاطعة',
    pleaseEnter: 'يرجى الإدخال',
    pleaseSelect: 'يرجى الاختيار',
    pleaseEnterTheName: 'يرجى إدخال اسمك',
    pleaseEnterTheEmail: 'يرجى إدخال بريدك الإلكتروني',
    pleaseEnterValidEmail: 'يرجى إدخال بريد إلكتروني صالح',
    pleaseEnterTheCompanyName: 'يرجى إدخال اسم الشركة',
    pleaseSelectTheDepartment: 'يرجى اختيار القسم',
    pleaseSelectTheRole: 'يرجى اختيار الدور الوظيفي',
    pleaseSelectTheCountry: 'يرجى اختيار الدولة',
    pleaseSelectTheProvince: 'يرجى اختيار المقاطعة',
    textIsRequired: 'هذه الخانة مطلوبة',
    submit: 'إرسال',
    download: 'تنزيل',
    submitSuccess: 'تم إرسال الطلب بنجاح',
    downloadSuccess: 'تم تنزيل الموارد بنجاح',
    title1: 'يرجى تعبئة معلوماتك للحصول على الموارد',
    title2: 'يرجى اختيار الموارد التي تريد تنزيلها',
  },
  dashboard: {
    pdf: {
      downloadReport: 'تحميل التقرير',
      downloadBtnText: 'تحميل PDF',
      content: 'المحتوى',
      theEnd: 'النهاية',
      thankYouForWatching: 'شكرا لك على المشاهدة.',
      pdfProcessing: 'يتم معالجة PDF...',
      pdfProcessingDesc:
        'PDF لوحة: {{count}}، متوقع أن يستغرق {{seconds}} ثانية، انقر فوق حفظ بعد ذلك، يرجى الاستمرار في الإنتظار',
      pdfProcessingDesc2: 'اللغة الحالية غير مترجمة، لا يمكن إنشاء PDF',
    },
    ppt: {
      downloadBtnText: 'تحميل PPT',
      pptProcessingDesc: 'جاري إنشاء ملف PPT، يرجى الانتظار بصبر',
      pptProcessingDesc2: 'لم تتم ترجمة إصدار اللغة الحالي، لا يمكن إنشاء ملف PPT',
      pptProcessingDesc3: 'جاري تحميل ملف PPT، يرجى الانتظار...',
      translateCompleted: 'اكتملت ترجمة PPT',
      exportSuccess: 'تم تصدير ملف PPT بنجاح',
      exportFailed: 'فشل تصدير ملف PPT',
    },
    layout: {
      projectMenuText: 'مشاريع اختبار الإعلانات',
      accountManagementText: 'إدارة الحساب',
      myAccountText: 'حسابي',
      subscriptionText: 'الاشتراك',
      logout: 'تسجيل الخروج',
      dataDetails: 'تفاصيل البيانات',
      dataAnalysis: 'تحليل البيانات',
      dataOverview: 'نظرة عامة على البيانات',
      dataComparison: 'مقارنة البيانات',
    },
    systemMessage: {
      title: 'رسالة النظام',
      task: 'المهمة',
      system: 'النظام',
      noRelevantContent: 'لا يوجد محتوى ذي صلة',
      noMore: 'لا توجد رسائل أخرى',
    },
    projectPage: {
      createProject: 'إنشاء مشروع',
      searchPlaceholder: 'أدخل اسم المشروع/الإعلان/العلامة التجارية للبحث',
      sortLabel: 'ترتيب مؤشر فعالية الإعلان',
      sortPlaceholder: 'يرجى اختيار طريقة الترتيب',
      sortOption1: 'بترتيب تصاعدي لمؤشر الفعالية',
      sortOption2: 'بترتيب تنازلي لمؤشر الفعالية',
      filterSort: 'تصفية وترتيب',
      filterBenchmarkTitle: 'تصفية القيمة القياسية',
      sortTitle: 'ترتيب',
      tabAllCreative: 'كل الإبداعات ({{count}})',
      tabGeneralCreative: 'الإبداعات العادية ({{count}})',
      tabSplashCreative: 'إبداعات شاشة البداية ({{count}})',
      generalCreativeLabel: 'إبداع عادي',
      splashCreativeLabel: 'إبداع شاشة البداية',
      normTypePlaceholder: 'يرجى اختيار نوع القيمة القياسية',
      totalDesc: 'مشاريع الإعلانات (إجمالي {{total}})',
      noRelevantContent: 'لا يوجد محتوى ذي صلة',
      loadMore: 'تحميل المزيد',
      projectCard: { delete: 'حذف', reanalyze: 'إعادة تحليل', download: 'تنزيل' },
      delete: 'حذف',
      cancel: 'إلغاء',
      message: {
        deleteTitle: 'تحذير الحذف',
        delete:
          'بمجرد حذف هذا المشروع، ستصبح جميع البيانات المرتبطة غير متاحة. هل أنت متأكد أنك تريد المتابعة في الحذف؟',
        delete1: 'هذا المشروع هو مشروع تجربة مجانية، وحذفه لن يعيد الفرصة التجريبية',
        delete2:
          'لم يبدأ هذا المشروع التحليل بعد. بعد الحذف، ستتم إعادة أرصدة الاختبار إليك',
        deleteSuccess: 'تم الحذف بنجاح!',
        analysisCountNotEnough: 'لا يوجد عدد كافي من التحليلات، يرجى الشحن للمتابعة.',
        analysisFailed: 'فشل التحليل، يرجى المحاولة مرة أخرى.',
        waitingQuestion:
          'يمكن تحليل 3 مشاريع كحد أقصى في نفس الوقت. دخل هذا المشروع في قائمة الانتظار، وسيبدأ التحليل تلقائياً لاحقاً.',
        landscapeQuickCompleted: 'اكتمل مشروع الاختبار السريع الأفقي الخاص بك.',
        portraitQuickCompleted: 'اكتمل مشروع الاختبار السريع العمودي الخاص بك.',
        landscapeSurveyCompleted: 'اكتمل مشروع الرؤى المتعمقة الأفقي الخاص بك.',
        portraitSurveyCompleted: 'اكتمل مشروع الرؤى المتعمقة العمودي الخاص بك.',
      },
    },
    projectCreatePage: {
      createProject: 'إنشاء مشروع',
      basicInformation: 'المعلومات الأساسية',
      projectType: 'نوع المشروع',
      projectName: 'اسم المشروع',
      categoryType: 'الصناعة',
      brandName: 'اسم العلامة التجارية',
      advertisingInformation: 'معلومات الإعلان',
      adName: 'اسم الإعلان',
      targetMarketNorm: 'القيمة القياسية للسوق المستهدف',
      norm: 'القيمة القياسية',
      brandNorm: 'القيمة القياسية للعلامة التجارية',
      taGender: 'جنس الجمهور المستهدف',
      targetMarket: 'السوق المستهدف',
      taAge: 'عمر الجمهور المستهدف',
      next: 'التالي',
      previous: 'السابق',
      confirmOrder: 'تأكيد الطلب',
      estTime: 'الوقت المتوقع',
      minutes: 'دقائق',
      consumption: 'استهلاك هذا الطلب',
      testPoint: 'عدد الاختبارات',
      remaining: 'متبقي',
      times: 'مرات',
      type: 'النوع',
      purchase: 'شراء',
      outputLanguage: 'اللغة المخرجة',
      durationCategory: 'نوع الإبداع',
      durationCategoryDesc: 'تختلف مؤشرات التحليل حسب نوع الإبداع، يرجى اختيار الخيار الأنسب للمحتوى',
      durationCategoryOptions: {
        tenPlus: 'إبداع عام (10 ث+)',
        fiveToTen: 'إبداع افتتاحي (5-10 ث)',
      },
      adSelection: {
        adCreativeTest: 'اختبار إبداع الإعلان',
        adCreativeTestDesc:
          'اختبار ردود فعل الجمهور المستهدف على إبداع إعلاني واحد، وتقديم تحليل وتوصيات',
        adCreativeSelection: 'اختيار إبداعات الإعلان',
        adCreativeSelectionDesc: 'مقارنة ردود الفعل على عدة إبداعات إعلانية، واختيار شامل',
        adCreativeEditing: 'تحرير إبداعات الإعلان',
        adCreativeEditingDesc:
          'تحديد الذكاء الاصطناعي لأفضل أجزاء الإبداع الإعلاني، وإنشاء الإبداع الإعلاني تلقائيًا',
        launchingSoon: 'سيتم الإطلاق قريبًا',
      },
      industryCategorySelect: {
        /**----------------------- */
        foodAndBeverageCategory: 'الأغذية والمشروبات',
        packagedFood: 'الأغذية المغلفة',
        confectionery: 'الحلويات',
        frozenMeals: 'الأطعمة المجمدة',
        fastFood: 'الطعام السريع',
        beverage: 'المشروبات',
        alcohol: 'الكحول',
        dairy: 'الألبان',
        grainAndSeasoning: 'الحبوب والتوابل',
        beverageMixes: 'المشروبات المختلطة',
        freshProduce: 'المحصولات الطازجة',
        otherFoodAndBeverage: 'الأغذية والمشروبات الأخرى',
        /**----------------------- */
        consumerElectronicsCategory: 'الإلكترونيات المستهلكة',
        mobilePhone: 'الهواتف المحمولة',
        computer: 'الحواسيب',
        smartDevice: 'الأجهزة الذكية',
        phoneAccessories: 'أدوات الهاتف',
        computerAccessories: 'أدوات الحاسوب',
        software: 'البرمجيات',
        camera: 'الكاميرات',
        officeSupplies: 'مستلزمات المكتب',
        otherConsumerElectronics: 'الإلكترونيات المستهلكة الأخرى',
        /**----------------------- */
        pharmaceuticalsAndHealthCareCategory: 'الأدوية والرعاية الصحية',
        otcMedicine: 'الأدوية المختلطة',
        prescriptionDrugs: 'الأدوية المصرح بها',
        healthSupplements: 'الأدوية الصحية',
        pharmaceuticalCompanies: 'شركات الأدوية',
        medicalDevices: 'الأجهزة الطبية',
        medicalServices: 'الخدمات الطبية',
        pharmacy: 'الصيدليات',
        otherPharmaceuticalsAndHealthCare: 'الأدوية والرعاية الصحية الأخرى',
        /**----------------------- */
        beautyAndPersonalCareCategory: 'الجمال والرعاية الشخصية',
        hairCare: 'العناية بالشعر',
        womenSkincare: 'العناية بالبشرة',
        homeCleaning: 'التنظيف المنزلي',
        bodyCare: 'العناية بالجسم',
        feminineCare: 'العناية بالمرأة',
        oralCare: 'العناية بالفم',
        menSkincare: 'العناية بالرجل',
        makeup: 'المكياج',
        fragrances: 'العطور',
        beautyServices: 'خدمات الجمال',
        otherBeautyAndPersonalCare: 'الجمال والرعاية الشخصية الأخرى',
        /**----------------------- */
        maternalAndInfantProductsCategory: 'المنتجات الأطفالية',
        babyFood: 'الأطعمة الأطفالية',
        babyCareEssentials: 'المستلزمات الأطفالية',
        babyToys: 'الألعاب الأطفالية',
        otherMaternalAndInfantProducts: 'المنتجات الأطفالية الأخرى',
        /**----------------------- */
        networkAndCommunicationCategory: 'الشبكات والاتصالات',
        mobileCarriers: 'شركات المحمول',
        internetProviders: 'شركات الإنترنت',
        telecomEquipment: 'أجهزة الاتصالات',
        otherNetworkAndCommunication: 'الشبكات والاتصالات الأخرى',
        /**----------------------- */
        travelAndAccommodationCategory: 'السفر والإقامة',
        localTourism: 'السفر المحلي',
        bookingPlatform: 'منصة الحجز',
        hotels: 'الفنادث',
        airlines: 'الطيران',
        airport: 'المطار',
        otherTravelAndAccommodation: 'السفر والإقامة الأخرى',
        /**----------------------- */
        vehiclesCategory: 'المركبات',
        motorVehicleProductsAndServices: 'المركبات والخدمات',
        carBrands: 'العلامات التجارية للسيارات',
        dealerships: 'الوكالات',
        carFinance: 'التمويل السيارات',
        evCar: 'سيارات الكهرباء',
        motorcycle: 'الدراجات النارية',
        onlineUsedCarMarketplace: 'منصة السيارات المستعملة عبر الإنترنت',
        carRentalPlatform: 'منصة الإيجار السيارات',
        travelNavigation: 'التطبيقات السياحية',
        bicycle: 'الدراجات الهوائية',
        otherVehicles: 'المركبات الأخرى',
        /**----------------------- */
        householdAppliancesCategory: 'الأجهزة المنزلية',
        majorAppliances: 'الأجهزة الكبيرة',
        healthAndPersonalCareAppliances: 'الأجهزة الصحية والشخصية',
        majorKitchenAndBathAppliances: 'الأجهزة المطبخية والحمام',
        smallKitchenAppliances: 'الأجهزة الصغيرة للمطبخ',
        environmentalAppliances: 'الأجهزة البيئية',
        cleaningAppliances: 'الأجهزة التنظيفية',
        otherHouseholdAppliances: 'الأجهزة المنزلية الأخرى',
        /**----------------------- */
        retailAndServiceCategory: 'التجارة والخدمات',
        onlineRetailEcommerce: 'التجارة الإلكترونية والتجارة الإلكترونية',
        departmentStores: 'المتاجر المتخصصة',
        lifeServices: 'الخدمات المنزلية',
        retailServicesAndDelivery: 'الخدمات التجارية/التوصيل',
        supermarkets: 'المتاجر السوبر',
        otherRetailAndService: 'التجارة والخدمات الأخرى',
        /**----------------------- */
        apparelCategory: 'الملابس والملحقات',
        footwear: 'الأحذية',
        clothing: 'الملابس',
        watchesWatchRetail: 'الساعات والمتاجر المتخصصة',
        jewelry: 'المجوهرات',
        bags: 'الحقائب',
        eyewearOpticalStores: 'العدسات والمتاجر المتخصصة',
        otherClothingAndAccessories: 'الملابس والملحقات الأخرى',
        /**----------------------- */
        homeImprovementAndFurnishingsCategory: 'التطوير المنزلي والتجديد',
        homeFurnishing: 'التجديد المنزلي',
        homeImprovement: 'التطوير المنزلي',
        otherHomeImprovementAndFurnishings: 'التطوير المنزلي والتجديد الأخرى',
        /**----------------------- */
        financialAndInsuranceCategory: 'المالية والتأمين',
        bank: 'البنوك',
        fintech: 'التكنولوجيا المالية',
        investmentAndFinancialServices: 'الاستثمارات والخدمات المالية',
        insurance: 'التأمين',
        otherFinancialAndInsurance: 'المالية والتأمين الأخرى',
        /**----------------------- */
        entertainmentAndLeisureCategory: 'الترفيه والراحة',
        socialApp: 'التطبيقات الاجتماعية',
        toysAndDolls: 'الألعاب والأطفال',
        concerts: 'المعارض والمهرجانات',
        events: 'الفعاليات الرياضية',
        movies: 'الأفلام',
        themeParks: 'المدن المطروحة',
        gambling: 'الألعاب الألية',
        onlineGaming: 'الألعاب الإلكترونية',
        tvChannels: 'القنوات التلفزيونية',
        otherEntertainmentAndLeisure: 'الترفيه والراحة الأخرى',
        /**----------------------- */
        industrialAndAgriculturalCategory: 'الصناعة والزراعة',
        industrialSupplies: 'المواد الصناعية',
        agriculturalSupplies: 'المواد الزراعية',
        otherIndustrialAndAgricultural: 'الصناعة والزراعة الأخرى',
        /**----------------------- */
        petLifeCategory: 'حياة الحيوانات',
        petFood: 'الأطعمة الحيوانية',
        petSupplies: 'المستلزمات الحيوانية',
        otherPetLife: 'حياة الحيوانات الأخرى',
        /**----------------------- */
        educationAndLearningCategory: 'التعليم والتعلم',
        onlineLearning: 'التعليم الإلكتروني',
        schools: 'المدارس',
        skillCourses: 'دورات المهارات',
        tutoring: 'التعليم المنزلي',
        universities: 'الجامعات',
        otherEducationAndLearning: 'التعليم والتعلم الأخرى',
        /**----------------------- */
        communityAndPublicServiceCategory: 'المجتمع والخدمات العامة',
        charityCampaigns: 'الحملات الخيرية',
        ngoAds: 'الإعلانات المنظمات غير الحكومية',
        otherCommunityAndPublicService: 'المجتمع والخدمات العامة الأخرى',
        /**----------------------- */
        otherCategory: 'الفئات الأخرى',
        governmentAdvertising: 'الإعلانات الحكومية',
        realEstateAdvertising: 'الإعلانات العقارية',
        otherAdvertising: 'الإعلانات الأخرى',
      },
      genderSelect: {
        male: 'ذكر',
        female: 'أنثى',
        all: 'الكل',
      },
      targetMarketSelect: {
        China: 'الصين',
        HongKongChina: 'هونغ كونغ، الصين',
        MacauChina: 'ماكاو، الصين',
        TaiwanChina: 'تايوان، الصين',
        Japan: 'اليابان',
        Korea: 'كوريا',
        Mongolia: 'منغوليا',
        Singapore: 'سنغافورة',
        Thailand: 'تايلاند',
        Vietnam: 'فيتنام',
        Malaysia: 'ماليزيا',
        Philippines: 'الفلبين',
        Indonesia: 'إندونيسيا',
        Cambodia: 'كمبوديا',
        Laos: 'لاوس',
        India: 'الهند',
        SaudiArabia: 'المملكة العربية السعودية',
        Turkey: 'تركيا',
        Israel: 'إسرائيل',
        UnitedArabEmirates: 'الإمارات العربية المتحدة',
        Qatar: 'قطر',
        Kuwait: 'الكويت',
        UnitedKingdom: 'المملكة المتحدة',
        France: 'فرنسا',
        Germany: 'ألمانيا',
        Netherlands: 'هولندا',
        Belgium: 'بلجيكا',
        Austria: 'النمسا',
        Italy: 'إيطاليا',
        Spain: 'إسبانيا',
        Portugal: 'البرتغال',
        Greece: 'اليونان',
        Sweden: 'السويد',
        Norway: 'النرويج',
        Finland: 'فنلندا',
        Denmark: 'الدنمارك',
        Estonia: 'إستونيا',
        Latvia: 'لاتفيا',
        Russia: 'روسيا',
        Poland: 'بولندا',
        CzechRepublic: 'جمهورية التشيك',
        Hungary: 'المجر',
        Romania: 'رومانيا',
        Bulgaria: 'بلغاريا',
        Slovakia: 'سلوفاكيا',
        Slovenia: 'سلوفينيا',
        Ukraine: 'أوكرانيا',
        UnitedStates: 'الولايات المتحدة',
        Canada: 'كندا',
        Mexico: 'المكسيك',
        Brazil: 'البرازيل',
        LatinAmerica: 'أمريكا اللاتينية',
        Australia: 'أستراليا',
        NewZealand: 'نيوزيلندا',
        Other: 'أخرى',
      },
      languageSelect: {
        english: 'الإنجليزية',
        chinese: 'الصينية',
        japanese: 'اليابانية',
        korean: 'الكورية',
        french: 'الفرنسية',
        traditionalChinese: 'الصينية التقليدية',
      },
      placeholder: {
        projectName: 'أدخل اسم المشروع',
        category: 'اختر الفئة',
        brandName: 'أدخل اسم العلامة التجارية',
        adName: 'أدخل اسم الإعلان',
        norm: 'يرجى اختيار القيمة المعيارية',
        taGender: 'اختر الجنس',
        targetMarket: 'اختر السوق المستهدف',
        taAge: 'اختر العمر',
        lowerLimit: 'الحد الأدنى',
        upperLimit: 'الحد الأقصى',
        outputLanguage: 'يرجى اختيار اللغة المخرجة',
      },
      step: {
        step1: 'إدخال معلومات المشروع',
        step2: 'تأكيد معلومات الطلب',
      },
      message: {
        success: 'تم الإنشاء بنجاح',
        videoDurationOver60s: 'مدة الفيديو تتجاوز {{max}} ثانية',
        videoDurationLessThan10s: 'مدة الفيديو أقل من {{min}} ثوانٍ',
        videoDurationNeedOver10s: 'يجب أن تكون مدة الفيديو أكثر من 10 ثوانٍ',
        videoDurationNeedWithin5To10s: 'يجب أن تكون مدة الفيديو بين 5 و10 ثوانٍ',
        videoDurationNotMatchDurationCategory: 'مدة الفيديو الحالية لا تفي بمتطلبات نوع المشروع هذا. يرجى إعادة رفع الفيديو ثم المحاولة مرة أخرى.',
        videoUploadingCannotSwitchDurationCategory: 'لا يمكنك تبديل نوع الإبداع أثناء تحميل الفيديو. يرجى الانتظار حتى يكتمل التحميل.',
        videoFormatOrDurationError: 'تعذّر قراءة تنسيق الفيديو أو مدته. يرجى التحقق من ملف الفيديو والمحاولة مرة أخرى.',
        videoSizeOver200M: 'حجم الفيديو يتجاوز 256 ميغابايت',
        videoLandscape: 'يجب أن يكون الفيديو في الشكل الأفقي',
        videoPortrait: 'يجب أن يكون الفيديو عمودياً',
        clickToUploadTestVideo: 'انقر لتحميل الفيديو التجريبي',
        uploadFailed: 'فشل التحميل، يرجى المحاولة مرة أخرى',
        uploadDesc1: 'يدعم ملفات الفيديو الأفقية بتنسيقات MP4, MOV،',
        uploadDescPortrait: 'يدعم ملفات الفيديو العمودية بتنسيقات MP4, MOV',
        uploadDesc2: 'الحد الأقصى لحجم الملف 256 ميجابايت',
        formNotCompleted: 'يرجى ملء جميع المعلومات',
        uploadAdVideo: 'يرجى تحميل فيديو الإعلان',
        inputInvalid: 'إدخال غير صالح',
        insufficientTestPoints: 'ليس لديك نقاط اختبار كافية. يرجى إعادة الشحن والمحاولة مرة أخرى.',
        reviewProjectInfo:
          'يرجى مراجعة معلومات مشروعك بعناية. بعد تأكيد الطلب، لن تكون التغييرات ممكنة.',
        waitingDesc:
          'يمكن تحليل 3 مشاريع كحد أقصى في نفس الوقت. دخل هذا المشروع في قائمة الانتظار، وسيبدأ التحليل تلقائياً لاحقاً.',
        ageRangeInvalid: 'النطاق العمري يدعم فقط 20-55',
        normDesc:
          'القيم المعيارية للصناعة أو البيانات التاريخية، المستخدمة للمقارنة الأفقية لأداء الإعلان.',
      },
    },
    projectDetailPage: {
      testResults: 'نتائج الاختبار',
      share: 'مشاركة',
      shareFailed: 'فشلت المشاركة',
      shareModal: {
        title: 'مشاركة',
        desc: 'انسخ النص أدناه وشاركه على وسائل التواصل الاجتماعي.',
        saveImage: 'حفظ الصورة',
        copyText: 'نسخ النص',
        copySuccess: 'تم النسخ',
        copyFailed: 'فشل النسخ',
        textTemplate:
          'رائع! لقد تفوق إبداعي بالذكاء الاصطناعي على {{score}}% من الأعمال المشابهة على AdEff! البيانات هي المعيار الحقيقي! اختبار AdEff للإبداعات بالذكاء الاصطناعي مجاني الآن. تحقّق من نتيجتك على {{hostname}}. احصل على 5 اختبارات مجانية، ونتمنى لك تقييمات مبهرة!',
      },
      sharePoster: {
        createdByYou: 'من إبداعك',
        scoreTemplate: 'تفوقت على <score>{{score}}</score> من إبداعات AIGC',
        statsAt: 'إحصائية بتاريخ ',
        certification: 'شهادة الإبداع',
        footerText: 'نتطلع لإبداعاتك المستمرة وتقديم أعمال عالية الجودة!',
      },
      basicInformation: 'المعلومات الأساسية',
      waiting: 'قيد الإنتظار',
      ongoing: 'قيد التنفيذ',
      failed: 'فشل',
      tryAgain: 'حاول مرة أخرى',
      videoAnalysisFailed: 'فشل تحليل الفيديو',
      message: { projectNotFound: 'لم يتم العثور على المشروع' },
      primaryAnalysis: 'المؤشرات الرئيسية',
      detailAnalysis: 'تحليل اللحظات',
      heatmapAnalysis: 'خريطة الحرارة',
      analysisStepDesc: 'أكمل الذكاء الاصطناعي جميع مهام التحليل، التحليل التفصيلي أدناه',
      analysisWaitingDesc:
        'يمكن تحليل 3 مشاريع كحد أقصى في نفس الوقت. دخل هذا المشروع في قائمة الانتظار، وسيبدأ التحليل تلقائياً لاحقاً.',
      aiTip: 'يتم إنشاء محتوى التقرير بواسطة الذكاء الاصطناعي وللإعتبار فقط',
      subAnalysisDescription: {
        adVideoScore: 'مؤشر فعالية الإعلان',
        adVideoScoreDesc:
          'مؤشر فعالية الإعلان هو مؤشر عام يمكنه توقع الآثار القصيرة والطويلة المتوقعة من الإعلان.',
        norm: 'المعيار',
        normDesc:
          'القيم المعيارية للصناعة أو البيانات التاريخية، المستخدمة للمقارنة الأفقية لأداء الإعلان.',
        attentionIndex: 'مؤشر الانتباه',
        attentionIndexDesc:
          'درجة تركيز الانتباه البصري للجمهور، تعكس قدرة الصورة الإعلانية على جذب الانتباه.',
        emotionIndex: 'مؤشر المشاعر',
        emotionIndexDesc:
          'درجة استثارة المشاعر الإيجابية لدى الجمهور، تعكس التقلبات العاطفية الفورية الناتجة عن الإعلان.',
        cognitionIndex: 'مؤشر الإدراك',
        cognitionIndexDesc:
          'تعكس درجة معالجة الإدراك لدى الجمهور، أي إلى أي مدى فكروا في محتوى الإعلان.',
        theGolden3Seconds: 'الثلاث ثواني الذهبية',
        theGolden3SecondsDesc:
          'الثلاث ثواني الأولى من الإعلان هي اللحظة الحاسمة التي تحدد نجاح الإعلان.',
        informationTransmission: 'لحظة المعلومات',
        informationTransmissionDesc:
          'تقييم قدرة لحظة المعلومات الإعلانية على جذب انتباه الجمهور المستهدف وإثارة اهتمامهم.',
        brandRelevance: 'لحظة العلامة التجارية',
        brandRelevanceDesc:
          'تقييم قدرة لحظة العلامة التجارية على جذب انتباه الجمهور المستهدف وإثارة اهتمامهم.',
        interestStimulation: 'لحظة الاهتمام',
        interestStimulationDesc: 'لحظة رئيسية تثير الاستجابة العاطفية وتفكير الجمهور النشط.',
        theEnding3Seconds: 'الثلاث ثواني الأخيرة',
        theEnding3SecondsDesc:
          'استنادًا إلى قانون الذروة والنهاية، فإن الثلاث ثواني الأخيرة من الإعلان هي اللحظة الحاسمة لتثبيت انتباه المشاهدين وتعزيز نقل المعلومات.',
      },
      infoDrawer: {
        basicInformation: 'المعلومات الأساسية',
        advertisingInformation: 'معلومات الإعلان',
        projectName: 'اسم المشروع',
        brandName: 'اسم العلامة التجارية',
        category: 'الصناعة',
        norm: 'القيمة القياسية للسوق المستهدف',
        normLabel: 'القيمة القياسية',
        brandNorm: 'المعيار التجاري',
        adName: 'اسم الإعلان',
        taGender: 'جنس الجمهور المستهدف',
        targetMarket: 'السوق المستهدف',
        taAge: 'عمر الجمهور المستهدف',
        ageRange: '{{start}} إلى {{end}} سنة',
        modify: 'تعديل',
        cancel: 'إلغاء',
        confirm: 'تأكيد',
      },
      videoView: {
        eyeMovementRatio: 'مؤشر الانتباه',
        cognitiveEngagement: 'مؤشر الإدراك',
        emotionRecognition: 'مؤشر المشاعر',
        subjectiveResponseCurve: 'منحنى الاستجابة الذاتية',
        realtimeData: 'البيانات الحقيقية',
        panoramicData: 'البيانات المتكاملة',
        indexAnalysis: 'تحليل المؤشرات',
        advantage: 'المزايا',
        disadvantage: 'العيوب',
        suggestions: 'التوصيات',
        adVideoScore: 'مؤشر فعالية الإعلان',
        norm: 'المعيار',
        analysisStepTitle1: 'فك تشفير المحتوى',
        analysisStepTitle2: 'توقع التعليقات',
        analysisStepTitle3: 'دمج البيانات',
        analysisStepTitle4: 'استنتاجات وتوصيات',
        analysisStepDesc1:
          'بدء فك تشفير المحتوى الإعلاني متعدد الأنماط، فك تشفير المرئي، وفك تشفير الصوت، وفك تشفير النص، وفك تشفير الهيكل...',
        analysisStepDesc2:
          'بدء توقع الاستجابة الذاتية للجمهور، بناءً على محتوى الإعلان، توقع بيانات حركة العين وEEG...',
        analysisStepDesc3: 'بدء دمج المحتوى الموضوعي للإعلان وبيانات الاستجابة الذاتية للجمهور...',
        analysisStepDesc4: 'بدء توليد الاستنتاجات والتوصيات بناءً على نموذج الاستنتاج...',
        keyResult: 'النتيجة الرئيسية',
        videoChart: {
          videoFailed: 'فشل تشغيل الفيديو',
          videoFailedAction:
            'يرجى التحديث والمحاولة مرة أخرى. إذا استمرت المشكلة بعد عدة تحديثات، يرجى التواصل معنا للحصول على المساعدة.',
        },
      },
      storyboardView: {
        summary: 'ملخص',
        advantages: 'المزايا',
        disadvantages: 'العيوب',
        suggestions: 'التوصيات',
        keyResult: 'النتيجة الرئيسية',
        norm: 'المعيار',
        theGolden3Seconds: 'الثلاث ثواني الذهبية',
        informationTransmission: 'لحظة المعلومات',
        brandRelevance: 'لحظة العلامة التجارية',
        interestStimulation: 'لحظة الاهتمام',
        theEnding3Seconds: 'الثلاث ثواني الأخيرة',
      },
      heatmapView: {},
    },
    accountPage: {
      email: 'البريد الإلكتروني',
      username: 'اسم المستخدم',
      password: 'كلمة المرور',
      setPasswordToEnableEmailLogin:
        'قم بتعيين كلمة المرور لتمكين تسجيل الدخول عبر البريد الإلكتروني',
      uid: 'UID',
      contactAndReceiveNotifications: 'الاتصال واستلام الإشعارات',
      receiveEmailsAboutAdeffLatestUpdatesWithThisEmail:
        'استلم رسائل بريد إلكتروني حول آخر تحديثات AdEff على هذا البريد الإلكتروني.',
      myWorkspace: 'مساحتي العمل',
      newRequest: 'طلب جديد',
      invitationCode: 'رمز الإحالة',
      userName: 'اسم المستخدم',
      invitationCodeDesc:
        'لكل فريق رمز دعوة فريد يستخدمه المستخدمون الجدد عند التسجيل للانضمام إلى الفريق',
      table: {
        userName: 'اسم المستخدم',
        email: 'البريد الإلكتروني',
        operation: 'العملية',
        admin: 'المسؤول',
        remove: 'إزالة',
        deny: 'رفض',
        approve: 'الموافقة',
      },
      message: {
        yourTeamIsFull:
          'فريقك ممتلئ. يمكنك الاتصال بنا للحصول على المزيد من الأعضاء أو إزالة أعضاء آخرين.',
        invitationLinkSent: 'تم إرسال رابط الدعوة إلى هذا البريد الإلكتروني!',
        removeReminder: 'تذكير بالإزالة',
        remove: 'إزالة',
        removeMember: 'بعد إزالة العضو، سيبقى المحتوى الذي أنشأه. هل ترغب في متابعة إزالة العضو؟',
        removeMemberSuccess: 'تمت إزالة العضو بنجاح!',
        ok: 'حسناً',
        contactUs: 'اتصل بنا',
        applicationProcessedSuccessfully: 'تمت معالجة الطلب بنجاح!',
        notificationSettingsTurnedOn: 'تم تفعيل إعدادات الإشعارات',
        notificationSettingsTurnedOff: 'تم إيقاف إعدادات الإشعارات',
        setPassword: 'تعيين كلمة المرور',
        passwordConfirm: 'تأكيد',
        passwordCancel: 'إلغاء',
        oldPassword: 'كلمة المرور القديمة',
        newPassword: 'كلمة المرور الجديدة',
        pleaseEnterTheOldPassword: 'يرجى إدخال كلمة المرور القديمة',
        pleaseEnterTheNewPassword: 'يرجى إدخال كلمة المرور الجديدة',
        incorrectEntryOfOriginalPassword: 'خطأ في إدخال كلمة المرور الأصلية',
        passwordUpdatedSuccessfully: 'تم تحديث كلمة المرور بنجاح',
        changeUsername: 'تغيير اسم المستخدم',
        confirm: 'تأكيد',
        cancel: 'إلغاء',
        username: 'اسم المستخدم',
        pleaseEnterTheNewUsername: 'يرجى إدخال اسم المستخدم الجديد',
        userNameUpdatedSuccessfully: 'تم تحديث اسم المستخدم بنجاح',
        addMemberToWorkspace: 'إضافة عضو جديد إلى مساحة العمل',
        notAdminOperate: 'ليس مسؤول، لا يمكن التعامل',
        emailAddress: 'عنوان البريد الإلكتروني',
        send: 'إرسال',
        willSendAnInvitationEmailToThisAddressForConfirmation:
          'سنرسل دعوة عبر البريد الإلكتروني إلى هذا العنوان للتأكيد.',
        workspaceMemberShip: 'عضوية مساحة العمل',
        forMoreMembership: 'المزيد من العضوية',
        reachedTheCeiling: 'تم الوصول إلى الحد الأقصى.',
        incorrectMailboxFormat: 'تنسيق البريد الإلكتروني غير صحيح',
        member: 'عضو',
        changeCorpNameTitle: 'تغيير اسم الشركة',
        changeCorpNameLabel: 'اسم الشركة',
        pleaseEnterTheCorpName: 'يرجى إدخال اسم الشركة',
        changeCorpNameSuccess: 'تم تغيير اسم الشركة بنجاح',
        changeCorpNameFailed: 'فشل تغيير اسم الشركة',
        noPermission: 'ليس لديك صلاحية لتغيير اسم الشركة',
      },
    },
    subscriptionPage: {
      currentPlan: 'الخطة الحالية',
      getInvoice: 'احصل على فاتورتك',
      remainingTimes: 'عدد المرات المتبقية',
      purchaseMore: 'شراء المزيد',
      contactUs: 'اتصل بنا',
      teamPlan: 'خدمات فريق الخبراء',
      unlimited: 'النسخة اللانهائية',
      dueDate: 'تاريخ الانتهاء',
      table: {
        usageRecords: 'سجلات الاستخدام',
        date: 'التاريخ',
        projectName: 'اسم المشروع',
        projectType: 'نوع المشروع',
        usageCount: 'مرات',
        userName: 'اسم المستخدم',
        noRelevantContent: 'لا يوجد محتوى ذي صلة',
      },
    },
    portraitDataDetailPage: {
      regularCreativeProject: 'مشروع إبداع عادي',
      regularCreative: 'إبداع عادي',
      splashCreativeProject: 'مشروع إبداع شاشة البداية',
      splashCreative: 'إبداع شاشة البداية',
      projects: 'المشاريع',
      localNorm: 'القيمة القياسية المحلية',
      projectPassRate: 'معدل نجاح المشروع',
      passRate: 'معدل النجاح',
    },
    dataDetailPage: {
      baseData: 'البيانات الأساسية',
      totalProjects: 'إجمالي المشاريع',
      totalProjectsDesc: 'عدد المشاريع الفعالة التي شاركت في تقييم فعالية الإعلانات.',
      // averageEffectivenessIndex: 'متوسط مؤشر الفعالية',
      // averageEffectivenessIndexDesc: 'متوسط مؤشر فعالية الإعلانات لجميع المشاريع الفعالة.',
      localNormProjects: 'عدد المشاريع القياسية للسوق المستهدف',
      brandNormProjects: 'عدد المشاريع القياسية للعلامة التجارية',
      normProject: 'المشروع القياسي للسوق المستهدف',
      brandNormProject: 'المشروع القياسي للعلامة التجارية',
      localNorm: 'القيمة القياسية للسوق المستهدف',
      localNormDesc:
        'متوسط مؤشر فعالية الإعلانات لمشاريع الإعلانات الفعالة التي تستهدف بلدك كسوق مستهدف.',
      norm: 'القيمة القياسية',
      brandNorm: 'القيمة القياسية للعلامة التجارية',
      brandNormDesc:
        'متوسط مؤشر فعالية الإعلانات لمشاريع الإعلانات الفعالة التي تستهدف القيمة القياسية للعلامة التجارية.',
      localProjectPassRate: 'معدل نجاح المشروع للسوق المستهدف',
      projectPassRate: 'معدل نجاح المشروع',
      brandProjectPassRate: 'معدل نجاح المشروع التجاري',
      projectPassRateDesc:
        'نسبة المشاريع التي حصلت على مؤشر فعالية أعلى من القيمة القياسية من إجمالي المشاريع المقيمة.',
      advertisingEffectivenessIndexDistribution: 'توزيع مؤشر فعالية الإعلانات',
      advertisingEffectivenessIndexDistributionDesc:
        'عرض نسبة المشاريع في مختلف فئات مؤشر فعالية الإعلانات.',
      item: 'عنصر',
    },
    dataComparisonPage: {
      createCompare: 'مقارنة جديدة',
      createCompareDesc: 'حدد عدة مشاريع للمقارنة، بحد أقصى 10 مشاريع.',
      startCompare: 'بدء المقارنة',
      compareReport: 'تقارير المقارنة',
      searchPlaceholder: 'ابحث عن اسم تقرير المقارنة',
      emptyText: 'لا توجد تقارير مقارنة حتى الآن. حدد المشاريع للمقارنة أولاً.',
      searchEmptyText: 'لم يتم العثور على تقارير مقارنة.',
      deleteTitle: 'حذف تقرير المقارنة',
      deleteConfirm: 'هل أنت متأكد من حذف تقرير المقارنة هذا؟ لا يمكن التراجع عن هذا الإجراء.',
      projectCount: '{{count}} مشاريع',
    },
    dataComparisonStartPage: {
      back: 'رجوع',
      basicInfo: 'المعلومات الأساسية',
      reportName: 'اسم التقرير:',
      reportNamePlaceholder: 'أدخل اسم تقرير المقارنة',
      norm: 'المعيار:',
      normPlaceholder: 'حدد المعيار',
      normTip: 'حدد المعيار المستخدم لمقارنة المشاريع',
      selectProject: 'تحديد المشاريع',
      searchPlaceholder: 'ابحث حسب المشروع/الإعلان/العلامة التجارية',
      selectedCountPrefix: ' تم تحديد ',
      selectedCountSuffix: ' مشاريع، حتى {{max}} مشاريع',
      startCompare: 'بدء المقارنة',
      save: 'حفظ',
      cancel: 'إلغاء',
      maxSelectedWarning: 'يمكنك تحديد ما يصل إلى 10 مشاريع',
      reportNameRequired: 'أدخل اسم تقرير المقارنة',
      normRequired: 'حدد المعيار',
      projectRequired: 'حدد المشاريع',
    },
    dataComparisonInfoPage: {
      defaultReportName: 'اسم تقرير المقارنة',
      reportNotFound: 'لم يتم العثور على التقرير',
      back: 'رجوع',
      modify: 'تعديل',
      deletedProjectTip: 'المشاريع التالية: {{names}} تم حذفها. بعد التأكيد سيتم تحديث تقرير المقارنة وإزالة المشاريع المحذوفة.',
      confirmDeletedProjects: 'تأكيد',
      metricScore: 'درجة المؤشر',
      tabDimension: 'خمسة أبعاد',
      tabMoment: 'اللحظة الرئيسية',
      tabAttitude: 'موقف المستهلك',
      adeffScore: 'درجة AdEff',
      brandName: 'اسم العلامة التجارية',
      projectName: 'اسم المشروع',
      industry: 'الصناعة',
      targetMarket: 'السوق المستهدف',
      gender: 'جنس TA',
      age: 'عمر TA',
      adProject: 'مشروع إعلاني',
      normLabel: 'المعيار',
      mixedCreativeBenchmarkTip: 'لا يتوفر معيار عند مقارنة الإبداعات العامة وإبداعات شاشة الفتح في الوقت نفسه.',
      emptyProject: 'حدد المشاريع لعرض بيانات المقارنة',
      viewProjectDetail: 'عرض تفاصيل المشروع',
      listSeparator: '، ',
      metricLabels: {
        attention: 'قوة الانتباه',
        infectivity: 'القوة العاطفية',
        delivery: 'قوة الرسالة',
        brand: 'قوة العلامة التجارية',
        persuasion: 'قوة الإقناع',
        gazeRecognition: 'التعرف على النظرة',
        emotionRecognition: 'التعرف على العاطفة',
        engagementRecognition: 'التعرف على التفاعل',
        goldenSeconds: 'الثلاث ثواني الذهبية',
        brandMoment: 'لحظة العلامة التجارية',
        productMoment: 'لحظة الاهتمام',
        messageMoment: 'لحظة المعلومات',
        endingSeconds: 'الثلاث ثواني الأخيرة',
        likeability: 'الإعجاب',
        newInformation: 'معلومات جديدة',
        messageRelevance: 'ملاءمة الرسالة',
        comprehension: 'الفهم',
        credibility: 'المصداقية',
        brandLinkage: 'ارتباط العلامة التجارية',
        uniqueness: 'التميّز',
        learnMoreIntent: 'الرغبة في معرفة المزيد',
        purchaseIntent: 'نية الشراء',
        recommendIntent: 'قابلية المشاركة',
        brandLikeabilityLift: 'زيادة الإعجاب بالعلامة التجارية',
        purchaseIntentionLift: 'زيادة نية الشراء',
        attentionIndex: 'مؤشر الانتباه',
        emotionIndex: 'مؤشر المشاعر',
        cognitionIndex: 'مؤشر الإدراك',
      },
    },
    experience: {
      projectDetailPage: {
        analysisCompleted: 'اكتمل مشروع تقييم إبداع إعلان TVC الخاص بك.',
        title: {
          text1: 'اختبار الإبداع الإعلاني',
          text2: 'تقرير الاختبار',
        },
        flowAnalysis: {
          desc1: 'يقوم AdEff بتفكيك إعلان الفيديو الخاص بك',
          desc2: 'اكتمل تفكيك الفيديو',
          desc3: 'جارٍ تحليل الانتباه البصري للمستهلكين',
          desc4: 'جارٍ تحليل موضع التركيز البصري بناءً على ملفات المستهلكين',
          desc5: 'جارٍ إنشاء خريطة حرارة الانتباه',
          desc6: 'تم إنشاء خريطة الحرارة الديناميكية',
          desc7: 'جارٍ قياس الاستجابات المعرفية العصبية',
          desc8: 'جارٍ تتبع النظر والعاطفة والتفاعل ثانيةً بثانية',
          desc9: 'جارٍ إنشاء منحنى الاستجابة العصبية',
          desc10: 'تم إنشاء منحنى الاستجابة العصبية',
          desc11: 'جارٍ تحليل الأداء في اللحظات الرئيسية',
          desc12: 'جارٍ قياس الاستجابات المعرفية العصبية خلال: الثواني الذهبية الثلاث، لحظة الرسالة، لحظة العلامة التجارية، ذروة الاهتمام، والثواني الثلاث الأخيرة',
          desc13: 'جارٍ دمج مقاييس اللحظات الرئيسية',
          desc14: 'اكتمل تحليل اللحظات الرئيسية',
          desc15: 'جارٍ تحليل اتجاهات المستهلكين',
          desc16: 'جارٍ تحليل الاتجاهات نحو العلامة التجارية والمنتج والمحتوى',
          desc17: 'جارٍ دمج مقاييس الاتجاهات',
          desc18: 'اكتملت مقاييس الاتجاهات',
          desc19: 'جارٍ إنشاء درجات قوى التأثير الخمس',
          desc20: 'درجات قوى التأثير الخمس جاهزة',
          desc21: 'اكتمل التحليل! تقرير أداء إعلانك جاهز',
          terminology: {
            thumbExpand: 'توسيع الصور المصغرة',
            thumbCollapse: 'طي الصور المصغرة',
            gazeRecognition: 'التعرف على النظرة',
            gazeRecognitionDesc: 'يقيس تركيز الانتباه البصري ويوضح مدى فعالية عناصر الإعلان في جذب تركيز المشاهد.',
            emotionRecognition: 'التعرف على العاطفة',
            emotionRecognitionDesc: 'يقيس المشاعر الإيجابية والاستجابات العاطفية الفورية التي يثيرها الإعلان.',
            engagementRecognition: 'التعرف على التفاعل',
            engagementRecognitionDesc: 'يقيس الانغماس والتفاعل، ويعكس الاستثمار الذهني في محتوى الإعلان.',
            theGolden3Seconds: 'أداء الثواني الذهبية الثلاث',
            theGolden3SecondsDesc: 'يقيّم فعالية محتوى الإعلان خلال أول 3 ثوانٍ.',
            keyMessage: 'أداء الرسالة الرئيسية',
            keyMessageDesc: 'يقيس قدرة لحظات المعلومات في الإعلان على جذب الانتباه وتحفيز الاهتمام.',
            brand: 'أداء العلامة التجارية',
            brandDesc: 'يقيّم جذب الانتباه الخاص بالعلامة التجارية وفعالية التفاعل.',
            interest: 'ذروة الاهتمام',
            interestDesc: 'يحدد قمم المحتوى التي تثير صدى عاطفياً وتفاعلاً عالياً.',
            ending3Seconds: 'أداء الثواني الثلاث الأخيرة',
            ending3SecondsDesc: 'يقيّم فعالية محتوى الإعلان في الثواني الثلاث الأخيرة.',
            score: 'الدرجة',
            benchmark: 'المعيار',
            metrics: 'المقاييس',
            attitudePart: {
              attitudeMetrics: 'مقاييس الاتجاهات',
              liking: 'الإعجاب',
              likingDesc: 'يقيس الموقف الذاتي للجمهور ومستوى الإعجاب العام بالإعلان.',
              newInformation: 'معلومات جديدة',
              newInformationDesc: 'يقيس ما إذا كان الجمهور يعتقد أنه حصل من الإعلان على معلومات قيّمة وغير معروفة سابقاً عن العلامة أو المنتج.',
              messageRelevance: 'ملاءمة الرسالة',
              messageRelevanceDesc: 'يقيس مدى إدراك الجمهور للمعلومات المنقولة في الإعلان على أنها مرتبطة به مباشرة.',
              comprehension: 'الفهم',
              comprehensionDesc: 'يقيس ما إذا كانت الرسالة الرئيسية للإعلان قد فُهمت بوضوح ودقة ودون جهد.',
              credibility: 'المصداقية',
              credibilityDesc: 'يقيس مدى اعتقاد الجمهور بأن المعلومات المنقولة صحيحة وموثوقة وجديرة بالثقة.',
              brandLinkage: 'ارتباط العلامة التجارية',
              brandLinkageDesc: 'يقيس قدرة الجمهور على ربط الإعلان بشكل صحيح وقوي بالعلامة التجارية المحددة.',
              uniqueness: 'التميّز',
              uniquenessDesc: 'يقيس ما إذا كان الإعلان يرسخ تصوراً واضحاً بأن للعلامة تميزاً قيّماً ومختلفاً عن المنافسين.',
              willing: 'الرغبة في معرفة المزيد',
              willingDesc: 'يقيس الاحتمال الذاتي لاتخاذ الجمهور خطوات نشطة لمعرفة المزيد عن العلامة أو المنتج بعد مشاهدة الإعلان.',
              purchase: 'نية الشراء',
              purchaseDesc: 'يقيس الاحتمال الذاتي لأن يفكر الجمهور في اختيار أو شراء منتج العلامة في المستقبل.',
              share: 'قابلية المشاركة',
              shareDesc: 'يقيس الاحتمال الذاتي لمشاركة الجمهور الإعلان أو معلومات العلامة مع الآخرين بشكل نشط.',
              brandLikeLift: 'زيادة الإعجاب بالعلامة التجارية',
              brandLikeLiftDesc: 'يقيس اتجاه ودرجة التغير في الإعجاب العام بالعلامة أو المنتج بعد التعرض للإعلان.',
              purchaseIntentLift: 'زيادة نية الشراء',
              purchaseIntentLiftDesc: 'يقيس اتجاه ودرجة التغير في الاستعداد للنظر في شراء منتج العلامة بعد التعرض للإعلان.',
            },
            dimensionPart: {
              forceDrives: 'قوى التأثير',
              attension: 'الانتباه',
              emotionalImpact: 'الأثر العاطفي',
              messageClarity: 'وضوح الرسالة',
              brandPower: 'قوة العلامة التجارية',
              persuasion: 'الإقناع',
              attentionForce: 'قوة الانتباه',
              attentionForceDesc: 'يقيس قدرة الإعلان على جذب انتباه الجمهور البصري والسمعي والحفاظ عليه.',
              emotionalForce: 'القوة العاطفية',
              emotionalForceDesc: 'يقيس شدة الرنين العاطفي الفوري والغريزي والتقلبات العاطفية التي يثيرها محتوى الإعلان.',
              messageForce: 'قوة الرسالة',
              messageForceDesc: 'يقيس فعالية تعرف الجمهور المستهدف على الرسالة الأساسية للإعلان بوضوح وفهمها بدقة وتذكرها بعمق.',
              brandForce: 'قوة العلامة التجارية',
              brandForceDesc: 'يقيس فعالية الإعلان في تعزيز هوية العلامة ورفع تفضيلها وبناء ارتباط قوي بها.',
              persuasiveForce: 'قوة الإقناع',
              persuasiveForceDesc: 'يقيس القوة النهائية للإعلان في تغيير التصورات ودفع النوايا السلوكية.',
            },
            result: {
              results: 'النتائج',
              pass: 'اجتاز',
              notPass: 'لم يجتز',
              adeffScore: 'درجة AdEff',
              adeffScoreDesc: 'تم تصميم درجة AdEff لقياس الفعالية الإجمالية للإعلانات.',
              benchmarkDesc: 'يُستخدم متوسط درجة AdEff لجميع الإعلانات المرفوعة في بلد أو منطقة الإعلان لمقارنة أداء الإعلان.',
            },
          },
        },
        pptAnalysis: {
          emptyState: {
            waiting: 'في الانتظار...',
            description: 'جارٍ إنشاء تقرير الاختبار لك...',
          },
          generating: 'جارٍ الإنشاء...',
          freeTrialLockText1: 'لا يمكن معاينة التقرير الكامل أو تنزيله في وضع التجربة.',
          freeTrialLockText2: 'اشترك لفتح الوصول.',
        },
      },
    },
  },
  professor: {
    account: 'الحساب',
    password: 'كلمة المرور',
    login: 'تسجيل الدخول',
    expertReviews: 'التقييمات الخبراء',
    adVideoScore: 'مؤشر فعالية الإعلان',
    subjectiveResponseCurve: 'منحنى الاستجابة الذاتية',
    indexAnalysis: 'تحليل المؤشرات',
    keyResult: 'النتيجة الرئيسية',
    theGolden3Seconds: 'الثلاث ثواني الذهبية',
    informationTransmission: 'لحظة المعلومات',
    brandRelevance: 'لحظة العلامة التجارية',
    interestStimulation: 'لحظة الاهتمام',
    theEnding3Seconds: 'الثلاث ثواني الأخيرة',
    heatMap: 'خريطة الحرارة',
    suggestion: 'التوصيات',
    suggestion1: 'التوصية',
    submit: 'إرسال',
    next: 'التالي',
    summary: 'ملخص',
    advantages: 'المزايا',
    disadvantages: 'العيوب',
    option1: 'متوقع',
    option2: 'غير متوقع',
    resultJudgment: 'التقييم',
    placeholder: 'أدخل توصية',
    waitRateCount: 'عدد الإعلانات المعلقة',
    unfinishedTitle: 'تنبيه',
    unfinishedRate: 'المشروع لديه عناصر غير مقيمة، هل تريد التأكيد على الخروج؟',
    unfinishedConfirm: 'استمرار التقييم',
    unfinishedCancel: 'خروج',
    message: {
      submitSuccess: 'شكرا لتقييمك',
      submitSuccess1: 'لقد قمت بتقييم هذا المشروع، شكرا لك',
      loginSuccess: 'تم تسجيل الدخول بنجاح',
      rateUnfinished: 'لم تقيم المحتوى الحالي بعد، يرجى ملء النموذج قبل الانتقال إلى السؤال التالي',
      rateLocation: 'لقد قمنا بتحديد العناصر غير المقيمة لك',
    },
  },
  modals: {
    freeTrialModal: {
      title: 'التقدم للحصول على تجربة',
      title1: 'تجربة مجانية',
      trial: 'تجربة',
      hiddenBoxText1: 'تم الكشف عن عدة مزايا وعيوب وتوصيات',
      hiddenBoxText2: 'اشترك للحصول على التقرير الكامل',
      hiddenBoxBtn: 'اشترك الآن',
      applyBox: {
        name: 'اسمك',
        tel: 'رقم الاتصال',
        department: 'القسم',
        role: 'الوظيفة',
        country: 'الدولة',
        city: 'المدينة',
        pleaseEnter: 'يرجى إدخال',
        pleaseSelect: 'يرجى التحديد',
        pleaseEnterTheName: 'يرجى إدخال اسمك',
        pleaseEnterTheTel: 'يرجى إدخال رقم الاتصال',
        pleaseEnterValidTel: 'يرجى إدخال رقم الاتصال الصالح',
        pleaseEnterValidEmail: 'يرجى إدخال بريد إلكتروني صالح',
        pleaseSelectTheDepartment: 'يرجى التحديد من القسم',
        pleaseSelectTheRole: 'يرجى التحديد من الوظيفة',
        pleaseSelectTheCountry: 'يرجى التحديد من الدولة',
        pleaseEnterTheCity: 'يرجى إدخال المدينة',
        textIsRequired: 'هذه الحقل مطلوب',
        submit: 'إرسال',
        tip: 'لكل شركة فقط فرصة واحدة للتجربة المجانية',
      },
      gotTrial: 'لقد حصلت على تجربة!',
      goPc: 'يرجى الذهاب إلى النسخة الويب المكتبية لإنشاء مشروعك.',
      back: 'العودة',
      country: {
        China: 'الصين',
        Japan: 'اليابان',
        Korea: 'كوريا',
        Indonesia: 'إندونيسيا',
        Thailand: 'تايلاند',
        Singapore: 'سنغافورة',
        Malaysia: 'ماليزيا',
        Vietnam: 'فيتنام',
        Germany: 'ألمانيا',
        Britain: 'المملكة المتحدة',
        France: 'فرنسا',
        Italy: 'إيطاليا',
        Russia: 'روسيا',
        Spain: 'إسبانيا',
        Turkey: 'تركيا',
        America: 'الولايات المتحدة',
        Canada: 'كندا',
        Brazil: 'البرازيل',
        Other: 'أخرى',
      },
      department: {
        Brand: 'العلامة التجارية',
        Market: 'السوق',
        Marketing: 'التسويق',
        IT: 'التكنولوجيا',
        Procurement: 'الشراء',
        Other: 'أخرى',
      },
      role: {
        President: 'الرئيس/المدير العام/المدير العام',
        CMO: 'المدير التنفيذي/المدير العام',
        Director: 'المدير',
        Manager: 'المدير التنفيذي',
        Other: 'أخرى',
      },
      message: {
        submitSuccess: 'تم إرسال الطلب بنجاح',
        submitFailed: 'فشل إرسال الطلب، يرجى المحاولة مرة أخرى لاحقًا',
      },
    },
    downloadPptRechargeModal: {
      title: 'لا يمكن تحميل التقرير',
      desc1: 'لا يمكن تحميل التقرير في وضع التجربة',
      desc2: 'اشترك للحصول على التقرير الكامل',
      btn: 'اشترك الآن',
    },
    checkInvitationCodeModal: {
      invitationCode: 'رمز الإحالة',
      invitationCodeDesc1: 'رمز الإحالة غير قابل للتعديل، يرجى الاتصال بنا إذا كنت ترغب في تعديله',
      invitationCodeDesc2: 'إذا كنت تستخدم هذا من خلال إحالة وكيل، يرجى إدخال رمز الإحالة',
      invitationCodePlaceholder: 'يرجى إدخال رمز الإحالة',
      invitationCodeError: 'رمز الإحالة غير صالح',
      invitationCodeSuccess: 'تم الربط بنجاح',
      ok: 'حسناً',
      cancel: 'إلغاء',
    },
    aigcPromotionModal: {
      title: 'مزايا منشئي AIGC',
      subTitle: 'سجّل الآن لتحصل على <tmp>5</tmp> فرص لتقييم فيديو بالذكاء الاصطناعي',
      desc1: 'انضم إلى فعالية AdEff لاختبار الإبداعات بالذكاء الاصطناعي لتقييم أعمالك الإبداعية.',
      desc2: 'سجّل الآن واحصل فورًا على 5 اختبارات مجانية.',
      registerBtn: 'سجّل للحصول على فرص الاختبار',
      tip: 'متاح فقط للمستخدمين الجدد الذين يسجلون عبر مدخل حملة منشئي AIGC',
      floatTitle: 'اختبار مجاني',
    },
  },
}

export default TRANSLATION
